import React from "react";
import {EvacuadosPorSector as EvacuadosPorSectorContainer} from '../../../containers/EvacuadosPorSector'
import { CAMPAIGN_2025 } from '../../../constants';

const EvacuadosPorSector = () => {
  return <EvacuadosPorSectorContainer campaign={CAMPAIGN_2025} year={2025}/>
};

export default EvacuadosPorSector;
